import {
  Box,
  Card,
  Flex,
  GlobeIcon,
  Image,
  MoreIcon,
  Typography,
} from '@iheartjane/reefer';
import { dedupeDispensary } from '@iheartjane/utils';
import Mustache from 'mustache';

import { us_states_map } from '@jane/shared/util';

import styles from './PreviewSeo.module.css';

const safeMustacheRender = (
  template: string,
  variables: Record<string, unknown>
): string => {
  try {
    return Mustache.render(
      template,
      variables,
      {},
      { escape: (text: string) => text }
    );
  } catch {
    return template;
  }
};

/** Mirrors Google's breadcrumb display, e.g. "example.com › shop › flower" */
const formatDisplayUrl = (url: string) => {
  const normalized = url.replace(/ /g, '-').toLowerCase();
  try {
    const { hostname, pathname } = new URL(normalized);
    return [hostname, ...pathname.split('/').filter(Boolean)].join(' › ');
  } catch {
    return normalized;
  }
};

const PreviewSeo = ({
  description,
  faviconUrl,
  menuUrl,
  title,
  variables,
}: {
  description?: string;
  faviconUrl?: string | null;
  menuUrl?: string;
  title?: string;
  variables: Record<string, unknown>;
}) => {
  const seoVariables = {
    ...variables,
    storeStateAbbr: us_states_map[variables['storeStateAbbr'] as string],
  };

  return (
    <Card style={{ '--card-border-radius': '16px' }}>
      <Card.Content p={24} background="grays-ultralight">
        <Flex flexDirection="column">
          <Typography color="grays-mid" variant="body-bold">
            Preview
          </Typography>
          <Box
            background="grays-white"
            p={24}
            mt={8}
            border="grays-light"
            style={{ borderRadius: '8px' }}
          >
            <Flex alignItems="center" gap={12}>
              <Box background="grays-ultralight" className={styles['favicon']}>
                {faviconUrl ? (
                  <Image
                    src={faviconUrl}
                    altText="Favicon"
                    height="18px"
                    width="18px"
                    objectFit="contain"
                  />
                ) : (
                  <GlobeIcon size="sm" color="grays-mid" />
                )}
              </Box>
              <Flex flexDirection="column">
                <Typography variant="small-body-regular" color="grays-black">
                  {variables['storeName'] as string}
                </Typography>
                <Flex alignItems="center" gap={4}>
                  <Typography variant="mini" color="grays-mid">
                    {formatDisplayUrl(menuUrl ?? '')}
                  </Typography>
                  <MoreIcon size="sm" rotate="right" color="grays-mid" />
                </Flex>
              </Flex>
            </Flex>
            <Typography variant="header" color="purple-dark" mt={12} mb={8}>
              {dedupeDispensary(safeMustacheRender(title ?? '', seoVariables))}
            </Typography>
            <Typography variant="small-body-regular" color="grays-dark">
              {dedupeDispensary(
                safeMustacheRender(description ?? '', seoVariables)
              )}
            </Typography>
          </Box>
        </Flex>
      </Card.Content>
    </Card>
  );
};

export default PreviewSeo;
